import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const POModal = ({ showModal, closeModal, branch, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showModal) {
      fetchSuppliers();
    }
  }, [showModal]);

  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/billHo_grnModal", {
        params: { branchcode: branch },
      });
      setAllSuppliers(response.data);
      setFilteredSuppliers(response.data); 
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSuppliers(allSuppliers);
    } else {
      const filtered = allSuppliers.filter(
        (item) =>
          item.prdetail_suppliercode.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.suppliermaster_Name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSuppliers(filtered);
    }
  }, [searchTerm, allSuppliers]);

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Bill Passing HO - Select View</h3>

        <div className="search-filter">
          <p>Search Supplier:</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type to search..."
          />
        </div>

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>GRN No</th>
                <th>GRN Date</th>
                <th>Branch</th>
                <th>Supplier Code</th>
                <th>Supplier Name</th>
                <th>D.C No</th>
                <th>D.C Date</th>
                <th>Inv. No</th>
                <th>Inv. Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="loading-text">Loading...</td>
                </tr>
              ) : filteredSuppliers.length > 0 ? (
                filteredSuppliers.map((item) => (
                  <tr key={item.GRNHeader_Number}>
                    <td>{item.GRNHeader_Number}</td>
                    <td>{new Date(item.GRNHeader_Date).toLocaleDateString('en-GB')}</td>
                    <td>{item.branchcode}</td>
                    <td>{item.GRNHeader_suppliercode}</td>
                    <td>{item.suppliermaster_name}</td>
                    <td>{item.GRNHeader_dcNumber}</td>
                    <td>{new Date(item.GRNHeader_dcDate).toLocaleDateString('en-GB')}</td>
                    <td>{item.GRNHeader_InvoiceNumber}</td>
                    <td>{new Date(item.GRNHeader_InvoiceDate).toLocaleDateString('en-GB')}</td>
                    <td>
                      <button className="select-btn" onClick={() => handleSelectItem(item)}>Select</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default POModal;
